/**
 * @author czy
 * 功能：货币服务类
 */

import { Service } from '@/tools'

export class FinancialCategoryService<T extends TCommodity.FinancialCategory> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCommodity.FinancialCategory}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 查询所有财务类目
  // /api/commodity/financialCategory/v1/page
  page = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)

  // 新增财务类目
  // /api/commodity/financialCategory/v1/add
  add = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAdd', data)

  // 修改财务类目 /api/commodity/financialCategory/v1/update
  update = <K extends T['ApiUpdate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdate', data)

  // 删除财务类目 /api/commodity/currency/v1/deleteById
  deleteById = <K extends T['ApiDeleteById']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteById', data)
  //查询财务类目列表/api/commodity/financialCategory/v1/findListByCondition
  findListByCondition = <K extends T['ApiFindListByCondition']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiFindListByCondition', data)
}
